module.exports = __webpack_public_path__ + "static/media/sort-amount-asc.691427cf.svg";